import { gql } from "@apollo/client";

export const GET_INVOICE_ITEMS = gql`
  query invoice_items($where: invoice_items_bool_exp) {
    invoice_items(where: $where, order_by: [{ sort_order: asc }, { name: asc }]) {
      id
      organization_id
      event_id
      name
      description
      amount
      tax_percentage
      service_fee_percentage
      sort_order
      is_active
      last_updated_by
      created_at
      updated_at
      event {
        id
        name
      }
      user {
        username
      }
    }
  }
`;

export const GET_INVOICE_ITEM = gql`
  query invoice_item($id: Int!) {
    invoice_items_by_pk(id: $id) {
      id
      organization_id
      event_id
      name
      description
      amount
      tax_percentage
      service_fee_percentage
      sort_order
      is_active
    }
  }
`;
